"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importStar(require("react"));
var AccessAuthenticationPageStateContext_1 = require("./AccessAuthenticationPageStateContext");
var QwilrLogoWithName_1 = require("./QwilrLogoWithName");
var styles = __importStar(require("./WhyVerify.css"));
var AccessAuthenticationTelemetry_1 = require("./AccessAuthenticationTelemetry");
var WhyVerify = function (_a) {
    var requestEmail = _a.requestEmail, validateEmail = _a.validateEmail;
    var setPageState = (0, AccessAuthenticationPageStateContext_1.useAccessAuthPageState)().setPageState;
    var telemetry = (0, AccessAuthenticationTelemetry_1.useAccessAuthTelemetry)();
    (0, react_1.useEffect)(function () {
        telemetry.track("Why Access Auth Verify Viewed");
    }, [telemetry]);
    var requirements = "identify themselves";
    if (validateEmail) {
        requirements = "identify and verify themselves by email";
    }
    else if (requestEmail) {
        requirements = "identify themselves by email";
    }
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("div", { className: styles.rainbowBar },
            react_1.default.createElement(kaleidoscope_1.RainbowBar, { isTopRounded: true, size: "small" })),
        react_1.default.createElement("div", { className: styles.mastheadWrapper },
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ChevronLeft, null), "aria-label": "Go back", onClick: function () {
                    setPageState({ page: "choose auth method" });
                }, className: styles.backButton }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(QwilrLogoWithName_1.QwilrLogoWithName, null))),
        react_1.default.createElement("div", { className: styles.contentWrapper },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", align: "center" }, "Why you need to verify"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                "The creator of this Qwilr page has required that anyone ",
                requirements,
                " before being allowed to view the page."),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                "Learn more about how your data is used in our",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/terms/" }, "terms and conditions"),
                " and",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/privacy-policy/" }, "privacy policy"),
                "."))));
};
exports.default = WhyVerify;
